<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-building page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2 disabled"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4" style="width:680px;">
							<div class="row g-2">
								<div class="col">
									<%- include('/ui/form', {
										params: [ 'search', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'machine_id',
												title: 'Cég',
												params: {
													maxItems: 1,
													options: terminals.data,
													valueField: 'machine_id',
													labelField: 'name',
													searchField: [ 'company_name' ],
													render: {
														item: (item, esc) => `<div>${esc(item.device_info.hostname)}</div>`,
														option: (item, esc) => `<div class="option"><span class="float-end text-warning">${esc(item.error_count)}</span><strong>${esc(item.device_info.hostname)}</strong><br /><small>${esc(item.company_name)} &bullet; ${esc(item.site_name)}</small></div>`
													},
													placeholder: '[ minden terminál ]'
												},
												unset_value: null,
												prepend: '<span class="input-group-text"><i class="fa fa-desktop"></i></span>',
												append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.machine_id = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.route(Anvil.href('/c_order/error_log/list', value ? { machine_id: value } : {}))
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto" style="width:300px;">
									<div class="input-group">
										<input type="text" class="form-control" id="text-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch()" />
										<span class="input-group-text"><i class="fa fa-search"></i></span>
									</div>
								</div>
							</div>
						</div>

						<h2>Hibanapló</h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
							<li class="breadcrumb-item active">Hibanapló</li>
						</ol>
					</div>

					<%- include('/ui/grid', {
						name: 'error_log',
						params: {
							row_class: (row) => {
								const terminal = Anvil.page.terminals.getByMachineId(row.hardware_uuid)
								if (terminal && terminal.sandbox) return 'bg-body-secondary text-dim'
								if (row.message.match(/ECONNRESET|ENOTFOUND|ETIMEDOUT|ECONNABORTED|ECONNREFUSED|EHOSTUNREACH|ENOENT|Kérés megszakítva|socket hang up/i)) return 'bg-body-secondary text-primary'
								if (row.message.match(/ACEC\_|MSACSRV|PC-AEE|Külső kijelző csatlakozási hiba/i)) return 'bg-body-secondary text-warning'
								if (row.message.match(/ER_LOCK_DEADLOCK|ER_LOCK_WAIT_TIMEOUT|ER_OUT_OF_SORTMEMORY|Deadlock found/i)) return 'bg-danger text-light'
								return ''
							},
							columns: [
								{
									title: 'ID',
									field: 'id',
									type: 'number',
									width: 60
								},
								{
									title: 'Verzió',
									field: 'version',
									type: 'string',
									width: 80
								},
								{
									title: 'Hibaüzenet',
									field: 'message',
									type: {
										render (value, row, options) {
											return new Option(value).innerHTML.substring(0, options.cutoff)
										}
									},
									options: {
										cutoff: 256
									},
									width: 620
								},
								{
									title: 'Időbélyeg',
									field: 'insert_dt',
									type: 'datetime',
									width: 160
								},
								{
									title: 'Ismétlődés',
									field: 'count',
									type: 'number',
									width: 100
								},
								{
									title: 'Cég',
									field: 'hardware_uuid',
									value: (v, row) => {
										const terminal = Anvil.page.terminals.getByMachineId(row.hardware_uuid)
										if (terminal) {
											return terminal.company_name
										} else {
											return ''
										}
									},
									type: 'string',
									width: 240
								},
								{
									title: 'Telephely',
									field: 'hardware_uuid',
									value: (v, row) => {
										const terminal = Anvil.page.terminals.getByMachineId(row.hardware_uuid)
										if (terminal) {
											return terminal.site_name
										} else {
											return ''
										}
									},
									type: 'string',
									width: 260
								},
								{
									title: 'Terminál',
									field: 'hardware_uuid',
									value: (v, row) => {
										const terminal = Anvil.page.terminals.getByMachineId(row.hardware_uuid)
										if (terminal) {
											return terminal.device_info.hostname
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											if (value) {
												return `<span style="color:dodgerblue;"><i class="fa fa-desktop me-2"></i><strong>${value}</strong></span>`
											} else {
												return ''
											}
										}
									},
									width: 220
								}
							]
						},
						list: error_log
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	init () {
		if (Anvil.page.search.machine_id) {
			Anvil.page.quickSearch()
		}
	},

	quickSearch () {
		const filters = []
		if (Anvil.page.search.machine_id) {
			filters.push(row => row.hardware_uuid == Anvil.page.search.machine_id)
		}

		const expression = $('#text-search').val()

		Anvil.models.components.Grid.find('#error_log_grid').filter(expression, filters)
	},

	refresh () {
		Anvil.exec('c_order/error_log/action_refresh')
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#error_log_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_order/error_log/modal_details', sel[0].id)
		}
	}
})

$('#error_log_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
